import React from 'react';
import './Divider.css';

export const Divider = () => {
  return <div className="divider"></div>;
};
